function SummaryCard({ item }) {
  return (
    <div className="summary-card">
      <img className="emoji" alt="imgplat" src={item?.img} />
      <br />
      <strong style={{ margin: 0 }}>{item?.name}</strong>
      <h3 style={{ margin: 0 }}>{item?.cantidad}</h3>
      <span>
        {item?.orders} órden{parseFloat(item?.orders) > 1 ? "es" : ""}
      </span>
    </div>
  );
}

export default SummaryCard;
